import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

export default function MainTabs({ tabIndexSelected }) {
	const navigate = useNavigate();
	return (
		<div class="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
			<ul class="flex flex-wrap -mb-px">
				<li class="me-2">
					<button
						onClick={() => {
							navigate("/home");
						}}
						class={`${
							tabIndexSelected === 0 ? "" : "border-transparent"
						} inline-block hover:text-slate-600 hover:border-slate-300 border-slate-500 border-b-4 rounded-t-lg py-2 px-6 text-base font-normal text-center`}
						id="profile-tab"
						data-tabs-target="#profile"
						type="button"
						role="tab"
						aria-controls="profile"
						aria-selected="true"
						aria-current="page">
						{tabIndexSelected === 0 ? <span class="font-bold bg-clip-text text-yellow-500">MUSIC ROOM</span> : <span>MUSIC ROOM</span>}
					</button>
				</li>
				<li class="me-2">
					<button
						onClick={() => {
							navigate("/fans");
						}}
						class={`${
							tabIndexSelected === 1 ? "" : "border-transparent"
						} inline-block hover:text-slate-600 hover:border-slate-300 border-slate-500 border-b-4 rounded-t-lg py-2 px-6 text-base font-normal text-center`}
						id="dashboard-tab"
						data-tabs-target="#dashboard"
						type="button"
						role="tab"
						aria-controls="dashboard"
						aria-selected="true">
						{tabIndexSelected === 1 ? <span class="font-bold bg-clip-text text-fuchsia-700">FANS</span> : <span>FANS</span>}
					</button>
				</li>
				<li class="me-2">
					<button
						onClick={() => {
							navigate("/releases");
						}}
						class={`${
							tabIndexSelected === 2 ? "" : "border-transparent"
						} inline-block hover:text-slate-600 hover:border-slate-300 border-slate-500 border-b-4 rounded-t-lg py-2 px-6 text-base font-normal text-center`}
						id="settings-tab"
						data-tabs-target="#settings"
						type="button"
						role="tab"
						aria-controls="settings"
						aria-selected="false">
						{tabIndexSelected === 2 ? <span class="font-bold bg-clip-text text-sky-500">RELEASES</span> : <span>RELEASES</span>}
					</button>
				</li>
				<li>
					<button
						onClick={() => {
							navigate("/labels");
						}}
						class={`${
							tabIndexSelected === 3 ? "" : "border-transparent"
						} inline-block hover:text-slate-600 hover:border-slate-300 border-slate-500 border-b-4 rounded-t-lg py-2 px-6 text-base font-normal text-center`}
						id="contacts-tab"
						data-tabs-target="#contacts"
						type="button"
						role="tab"
						aria-controls="contacts"
						aria-selected="false">
						{tabIndexSelected === 3 ? <span class="font-bold bg-clip-text text-emerald-500">LABELS</span> : <span>LABELS</span>}
					</button>
				</li>
				<li>
					<button
						onClick={() => {
							navigate("/promoters");
						}}
						class={`${
							tabIndexSelected === 4 ? "" : "border-transparent"
						} inline-block hover:text-slate-600 hover:border-slate-300 border-slate-500 border-b-4 rounded-t-lg py-2 px-6 text-base font-normal text-center`}
						id="contacts-tab"
						data-tabs-target="#contacts"
						type="button"
						role="tab"
						aria-controls="contacts"
						aria-selected="false">
						{tabIndexSelected === 4 ? <span class="font-bold bg-clip-text text-red-400">PROMOTERS</span> : <span>PROMOTERS</span>}
					</button>
				</li>
			</ul>
		</div>
	);
}

MainTabs.propTypes = {
	tabIndexSelected: PropTypes.number
};
